export default __webpack_public_path__ + "static/contact-bg-43c94962c769c7afedc006935c4ed60f.png";